import { isBring } from '@glow/common'
import { SessionUser } from '../types/coreEntitiesTypes'
import { stripBase, withBase } from './appBase'

export const isAuthPath = () => stripBase(location.pathname).indexOf('/auth/') !== -1

export const isOpenPath = () => stripBase(location.pathname).indexOf('/open/') === 0

export const userRequiresPwdLogin = (user: SessionUser) => user.get('passwordLoginRequired')

const BRING_PRIVACY_POLICY_URL = 'https://www.bring.com/privacy-policy'
const GLOW_PRIVACY_POLICY_URL = 'https://glowtechnology.com/privacy-statement-for-glow'

export const getPrivacyPolicyUrl = () => (isBring() ? BRING_PRIVACY_POLICY_URL : GLOW_PRIVACY_POLICY_URL)

/**
 * A redirect-to value we are willing to send the browser to after login: a path on this origin.
 * Rejects absolute URLs (`https://…`), protocol-relative ones (`//host`), backslash variants some
 * browsers normalise to a host, and any control character — browsers strip tabs and newlines from
 * URLs, so `/\t//evil` would otherwise resolve to an external host. Defence in depth only — the backend validates the same
 * value before redirecting, and that check is the actual boundary.
 */
export const isSafeRedirectTarget = (value: string): boolean => /^\/(?![/\\])[^\\\p{Cc}]*$/u.test(value)

/**
 * The SSO link. The backend carries `redirect-to` through the OIDC round-trip as `state` and
 * redirects the browser there afterwards (glow/auth/Msal.kt), and that redirect is absolute — so
 * this is the one place a router-relative redirect-to becomes absolute. Defaulting to the mount
 * root means a tester who opens a branch link and logs in lands on that branch, not on master.
 */
export const ssoInitiateHref = (search: string): string => {
  const params = new URLSearchParams(search)
  const requested = params.get('redirect-to')
  const target = requested !== null && isSafeRedirectTarget(requested) ? requested : '/'
  params.set('redirect-to', withBase(target))
  // Keep '/' literal in redirect-to, as the pre-existing link did; the backend decodes either form.
  return `/api/oidc/initiate?${params.toString().replace(/%2F/gi, '/')}`
}
